import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VersionService } from 'src/app/services/version.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-updateprompt',
  templateUrl: './updateprompt.component.html',
  styleUrls: ['./updateprompt.component.scss']
})
export class UpdatepromptComponent implements OnInit {

  @ViewChild('detailDialog') detailDialog: TemplateRef<any>;

  constructor(public versionService: VersionService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  openPopup() {
    // this.versionService.hidePrompt()
    const title = 'APPLICATION UPDATE NOTICE';
    const txt = "We've recently updated the Web Application, You may have refresh your browser before logging in";
    const OK = 'See Updates'
    swal.fire({
      title,
      text: txt,
      icon: 'info',
      showCancelButton: true,
      html: `<div class='d-flex flex-column' style="gap: 10px"><div>${txt}</div><div style="text-align: left;">
      <p style="font-weight: bold; font-size: 14px; margin: 10px 0 5px; text-align: center">If you're having trouble, try these steps:</p>
            <ol style="margin: 0; font-size: 14px; gap: 10px;">
              <li>Refresh the page with &nbsp;&nbsp;<strong><img src="./assets/images/reloadkeys.png" alt="CTRL + SHIFT + R" style="width: 150px; height: 20px;"></strong>&nbsp;&nbsp; to clear your cache.</li>
              <li>Try logging in again.</li>
            </ol>
      </div></div>`,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: OK,
      cancelButtonText: 'OK',
      customClass: {
        popup: 'custom-swal-width'
      }
    }).then(res => {
      if(res.isConfirmed){
        this.router.navigate(['/auth/updates']);
      }
    })
  }

}
